import type { OrganizationRole } from '@/api/generated';

/**
 * What each of the two organization roles may do, in the words the Users page
 * shows beside them.
 *
 * In one place because two dialogs say it - inviting somebody and changing
 * their role - and a Super Admin choosing a role should read the same promise
 * both times.
 */

/** Admin first: it is the smaller role, and the one most people are given. */
export const ROLE_ORDER: OrganizationRole[] = ['ADMIN', 'SUPER_ADMIN'];

export const ROLE_SUMMARIES: Record<OrganizationRole, string> = {
  ADMIN:
    'Creates and publishes the organization’s content: notifications, campaigns, guides, surveys, pages and documents.',
  SUPER_ADMIN:
    'Everything an Admin can do, plus managing users, the profile and billing.',
};

/** What changes for somebody moved into this role, said before it is done. */
export const ROLE_CHANGE_EFFECTS: Record<OrganizationRole, string> = {
  SUPER_ADMIN: 'They will be able to manage users, the profile and billing.',
  ADMIN: 'They will no longer manage users, the profile or billing.',
};
